import { DEFAULT_PREFIX } from "@giantmachines/redux-websocket";

export const SocketSettings = {
  DEFAULT: { reconnectOnClose: true },
  MACHINE: { reconnectOnClose: true },
  CAMERA: { reconnectOnClose: true },
  TRAIN: { reconnectOnClose: true },
  PREDICTION: { reconnectOnClose: true },
  DEPLOY: { reconnectOnClose: true },
  DOWNLOAD: { reconnectOnClose: false },
};
